
import React, { useState } from "react";
import SimpleBar from 'simplebar-react';
import { useLocation } from "react-router-dom";
import { CSSTransition } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faFileAlt, faSignOutAlt, faTable, faTimes, faHome, faStepBackward, faTransgender, faUsers } from "@fortawesome/free-solid-svg-icons";
import { Nav, Badge, Image, Button, Dropdown, Accordion, Navbar } from '@themesberg/react-bootstrap';
import { Link } from 'react-router-dom';

import { Routes } from "../routes";
import ReactHero from "../assets/img/technologies/react-hero-logo.svg";
import ProfilePicture from "../assets/img/team/profile-picture-3.jpg";
import SidebarItem from "./sidebar/SidebarItem";

import { countEnabledPermissions } from '../helper/permission'

export default (props = {}) => {
  const location = useLocation();
  const [show, setShow] = useState(false);
  const showClass = show ? "show" : "";

  const onCollapse = () => setShow(!show);

  const permission = localStorage.getItem('permission') || ""
  const permissionPoint = countEnabledPermissions(permission)

  return (
    <>
      <Navbar expand={false} collapseOnSelect variant="dark" className="navbar-theme-primary px-4 d-md-none">
        <Navbar.Brand className="me-lg-5" as={Link} to={Routes.Overview.path}>
          <Image src={ReactHero} className="navbar-brand-light" />
        </Navbar.Brand>
        <Navbar.Toggle as={Button} aria-controls="main-navbar" onClick={onCollapse}>
          <span className="navbar-toggler-icon" />
        </Navbar.Toggle>
      </Navbar>
      <CSSTransition timeout={300} in={show} classNames="sidebar-transition">
        <SimpleBar className={`collapse ${showClass} sidebar d-md-block bg-primary text-white`}>
          <div className="sidebar-inner px-4 pt-3">
            <div className="user-card d-flex d-md-none align-items-center justify-content-between justify-content-md-center pb-4">
              <div className="d-flex align-items-center">
                <div className="user-avatar lg-avatar me-4">
                  <Image src={ProfilePicture} className="card-img-top rounded-circle border-white" />
                </div>
                <div className="d-block">
                  <h6>Hi, Jane</h6>
                  <Button as={Link} variant="secondary" size="xs" to={Routes.Signin.path} className="text-dark">
                    <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Sign Out
                  </Button>
                </div>
              </div>
              <Nav.Link className="collapse-close d-md-none" onClick={onCollapse}>
                <FontAwesomeIcon icon={faTimes} />
              </Nav.Link>
            </div>
            <Nav className="flex-column pt-3 pt-md-0">
              {(permissionPoint > 1) &&
                <SidebarItem title="Quay về" link={Routes.Overview.path} icon={faStepBackward} setShow={setShow} />
              }

              <SidebarItem title="Trang chủ" link={Routes.Overview.path} icon={faHome} setShow={setShow} />

              <SidebarItem title="Trò chơi" link={Routes.SettingGames.path} setShow={setShow} />
              <SidebarItem title="Quảng cáo" link={Routes.SettingBanner.path} setShow={setShow} />
              <SidebarItem title="Thanh toán & Nạp rút" link={Routes.SettingAccount.path} setShow={setShow} />
              <SidebarItem title="Ngân hàng" link={Routes.SettingBank.path} setShow={setShow} />
              <SidebarItem title="Thông báo" link={Routes.SettingNotification.path} setShow={setShow} />
              <SidebarItem title="OTP Zalo" link={Routes.SettingZalo.path} setShow={setShow} />
              <SidebarItem title="Điều khoản & Liên hệ" link={Routes.SettingPrivacy.path} setShow={setShow} />
              <SidebarItem title="Phí dịch vụ" link={Routes.SettingFee.path} setShow={setShow} />
              <SidebarItem title="Crawler kết quả" link={Routes.SettingCrawler.path} setShow={setShow} />
              <SidebarItem title="SePay" link={Routes.SettingSePay.path} setShow={setShow} />
              <SidebarItem title="Bảo trì" link={Routes.SettingMaintained.path} icon={faTransgender} setShow={setShow} />
              <SidebarItem title="Tài liệu hệ thống" link={Routes.SettingHandoverDocs.path} icon={faBook} setShow={setShow} />
            </Nav>
          </div>
        </SimpleBar>
      </CSSTransition>
    </>
  );
};
